const postParametersViewModule = () => import(/* webpackChunkName: 'components/postParametersView' */'../postParameters/postParameters');

import { FiltersModel } from '../searchFilters/searchFiltersModel';
import { getSeason } from '../../utils/js/getSeason';
/**
 * Model regroupant tous les modèles concernés par le moteur (principal / filtres / résultats)
 */
const SearchModel = Backbone.Model.extend({
  defaults: {
    mainSearch: null,
    temporarySearch: null,
    filters: null,
    tempFilters: null,
    memoForMobile: null, // TODO : à supprimer lorsqu'on aura modifié la version mobile
    totalResults: 6,
    JSON_results: null, // Utilisé pour éviter de faire des requêtes lorsque ce n'est pas nécessaire (ouverture des filtres)
    temporaryJSON_results: null, // Utilisé pour tout ce qui concerne des modifications de critères de recherche non validés (mainsearch & filter sous mobile)
    ajaxParametersCache: {},
    ajaxParametersTempCache: {},
    resume: {},
    order: typeof SEARCH_SCRIPTS !== 'undefined' && typeof SEARCH_SCRIPTS.ORDER_BY !== 'undefined' ? SEARCH_SCRIPTS.ORDER_BY : 'desc',
    sort: typeof SEARCH_SCRIPTS !== 'undefined' && typeof SEARCH_SCRIPTS.DEFAULT_SORTING !== 'undefined' ? SEARCH_SCRIPTS.DEFAULT_SORTING : 'popularity',
    hasPagination: false,
    articleMessage: false,
    lat: null,
    long: null,
    url_searchTarget: typeof SEARCH_SCRIPTS !== 'undefined' && typeof SEARCH_SCRIPTS.URL_SEARCH !== 'undefined' ? SEARCH_SCRIPTS.URL_SEARCH + '?' : '',
    page: 1,
    eventType: false, // To flag action, for tracking or callback actions. Had to be emptied after result rendering
    storedSearchParameters: cookieManagement.getCookie('storedSearchParams') !== null ? JSON.parse(cookieManagement.getCookie('storedSearchParams')) : {},
    dayType: '', // TODO : à supprimer lorsqu'on séparera les deux moteurs
    isFlexPeriod: false,
    flexZone: ''
  },

  /**
   * Init Global Search model
   * @param {Object} options
   * @param {boolean} options.hasPagination
   */
  initialize(options = {}) {
    if (typeof GLOBAL_SCRIPTS.POST_PARAMS_INITIATED === 'undefined') {
      // On instancie la vue qui permet l'envoi des params en post qu'une seule fois (double appel sur la product cottages)
      postParametersViewModule().then(({PostParametersView}) => {
        new PostParametersView();
      });
    }

    this.model = new MainEngineModel(true);
    window.model = this.model;

    const filters = new FiltersModel();
    const datas = {
      mainSearch: new MainEngineModel(true),
      temporarySearch: new MainEngineModel(true),
      filters: filters,
      tempFilters: filters !== null && DEVICE.isMobile ? new FiltersModel() : null,
      hasPagination: typeof options.hasPagination !== 'undefined' ? $('#js-resultList').length ? $('#js-resultList[data-has-pagination="true"]').length && options.hasPagination : options.hasPagination : false
    };
    this.contextParameters = {
      c: SEARCH_SCRIPTS.COLLECTION,
      univers: GLOBAL_SCRIPTS.UNIVERS,
      language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
      market: GLOBAL_SCRIPTS.MARKET_CODE,
      token: GLOBAL_SCRIPTS.SEARCH_TOKEN,
      type: SEARCH_SCRIPTS.PAGETYPE,
      item: SEARCH_SCRIPTS.ITEMCODE, // code produit lorsqu'on est sur un onglet product, id de la collection sck si page offre, vide si search
      _controller: SEARCH_SCRIPTS.CONTROLLER, // variable utilisée pour déterminer quel cache utiliser pour les appel ajax des bypass
      group: SEARCH_SCRIPTS.GROUP, // type de liste de résultat
      currency: SEARCH_SCRIPTS.CURRENCY_CODE,
      accreditation: GLOBAL_SCRIPTS.ACCREDITATION,
      accreditationGroup: GLOBAL_SCRIPTS.ACCREDITATION_GROUP,
      cacheuser: GLOBAL_SCRIPTS.CACHE_USER
    };

    this.hasResultsList = typeof isResultList !== 'undefined' && isResultList;
    this.set(datas, {silent: true});

    // Specification for temporary model
    this.get('temporarySearch').set({isTemp: true}, {silent: true});

    // Listener instantiation
    this.stopListening(dispatcher, 'searchModel:updateSearchValues');
    this.listenTo(dispatcher, 'searchModel:updateSearchValues', this.updateSearchValues);

    // Model watch management
    this.stopListening(this, 'change');
    this.listenTo(this, 'change', this.modelWatch, true);

    // Management of the consequences of data updates
    this.stopListening(dispatcher, 'searchModel:globalSearchUpdate');
    this.listenTo(dispatcher, 'searchModel:globalSearchUpdate', this.globalSearchUpdate);

    this.stopListening(dispatcher, 'searchModel:updateSearchParams');
    this.listenTo(dispatcher, 'searchModel:updateSearchParams', this.getSearchParams);

    this.stopListening(dispatcher, 'searchModel:getJsonDatas');
    this.listenTo(dispatcher, 'searchModel:getJsonDatas', this.getJsonDatas);

    this.stopListening(dispatcher, 'searchModel:searchRequestEvent').listenTo(dispatcher, 'searchModel:searchRequestEvent', this.triggerSearchRequestEvent);
  },

  /**
   * Get resume of this model
   * @return {Object}
   */
  getResume() {
    const resume = {
      order: this.get('order'),
      sort: this.get('sort'),
      mainSearch: this.get('mainSearch').getResume(),
      temporarySearch: this.get('temporarySearch').getResume(),
      filters: this.has('filters') ? this.get('filters').getResume() : null
    };

    this.set('resume', resume, {'silent': true});

    return resume;
  },

  /**
   * Transfer values between models
   * @param {string?} modelType - can be "temporary" or anything else
   */
  updateSearchValues(modelType) {
    if (modelType === 'temporary') {
      this.get('temporarySearch').set(this.get('mainSearch').getResume(), {'silent': true});
    } else {
      this.get('mainSearch').set(this.get('temporarySearch').getResume());
    }
  },

  /**
   * The modelWatch only monitors values that are not related to other models
   */
  modelWatch() {
    const arrKeys = Object.keys(this.changedAttributes());
    const arrKeysToWatch = ['page', 'dayType', 'order', 'sort'];

    // If the pagination is not changed, it is put back to page 1
    if (_.indexOf(arrKeys, 'page') === -1) {
      this.set({'page': 1}, {'silent': true});
    }

    if (_.intersection(arrKeys, arrKeysToWatch).length) {
      const updateParams = {
        isTemporaryModel: false,
        arrKeys: arrKeys
      };
      this.globalSearchUpdate(updateParams);
    }
  },

  /**
   * Fonction pour gérer les actions en cas de changement
   * de valeur dans les données impactantes du moteur de recherche
   * @param {Object} updateParams
   * @param {Array} updateParams.arrKeys
   * @param {boolean} updateParams.isTemporaryModel
   */
  globalSearchUpdate(updateParams) {
    const arrKeys = updateParams.arrKeys;
    const modifiedKey = arrKeys[0];
    const isTemporaryModel = updateParams.isTemporaryModel;
    const lastFilter = this.has('filters') ? this.get('filters').get('lastModifiedFilter') : '';

    dispatcher.trigger('searchView:memoChanging'); // Memorizing model change status to handle delayed click

    /**
     * Lancement des renders une fois le JSON chargé
     * @param {Object} datas
     * @param {string} datas.status
     * @param {Object} datas.results
     * @param {string} datas.results.uri
     * @param {Object} datas.results.filter
     */

    const globalSearchUpdate_successCallback = (datas) => {
      if (datas.status === 'success') {
        if (!isTemporaryModel) {
          if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
            $('.js-compareButton').attr('data-src', `${GLOBAL_SCRIPTS.BASELINK}/compare${datas.results.uri}`);
          }
          // Enregistrement du json dans le modele
          this.set({'JSON_results': datas}, {'silent': true});

          let urlSeo = datas.results.uri.replace('?', '');

          if (this.get('temporarySearch').get('isFlexPeriod')) {
            urlSeo += '&option[date_range]=1&option[flexholiday]=1';
            const flexZone = this.get('temporarySearch').get('flexZone');

            if (flexZone !== '') {
              urlSeo += '&flexZone=' + flexZone;
            }
          }

          const facetteDiscount = typeof datas.results !== 'undefined' && typeof datas.results.filter !== 'undefined' && typeof datas.results.filter.promocode !== 'undefined' ? datas.results.filter.promocode : false;
          const submitForm = _.indexOf(arrKeys, 'submitForm') > -1;

          // Mise à jour des postParams
          if (GLOBAL_SCRIPTS.CONTROLLER === 'product' && (!submitForm || (submitForm && PRODUCT_SCRIPTS.PRODUCT_TAB !== `tab_${GLOBAL_SCRIPTS.UNIVERS}_domain`))) {
            const postParamsUri = '?' + urlSeo;

            dispatcher.trigger('postParams:globalUpdate', postParamsUri);
          }

          // Si la page ne comporte pas de liste de résultats, la validation du formulaire principal redirige vers une page de résultats
          if (submitForm && !this.hasResultsList) {
            const submitFct = () => {
              /**
               * Le paramètre is_user_search ajouté ci-dessous sert à différencier le cas où on arrive sur
               * une page search via soumission de formulaire des autres cas.
               * Cela est utile à la team WebA pour l'event "search_request".
              */
              window.location = this.get('url_searchTarget') + urlSeo + '&is_user_search=1';
            };

            dispatcher.trigger('search:memorizingMainSearchCriteria', submitFct);
          } else {
            const isResetAllFilters = this.has('filters') ? this.get('filters').get('isResetAllFilters') : false;
            const backToPreviousFilters = _.indexOf(arrKeys, 'backToPreviousFilters') > -1; // Lorsqu'on modifie un filtre avec auto-correlation, il faut mettre à jour son affichage

            if (!isResetAllFilters) {
              if (lastFilter === 'ACTIVITIES') {
                dispatcher.trigger('search:filters:render', 'activities', true, backToPreviousFilters);
              } else if (lastFilter === 'HOUSINGCATEGORY' || lastFilter === 'HOUSINGSPEC') {
                dispatcher.trigger('search:filters:render', 'housingcategory', true, backToPreviousFilters);
              } else if (lastFilter === 'NUMBEROFBEDROOMS') {
                dispatcher.trigger('search:filters:render', 'numberofbedrooms', true, backToPreviousFilters);
              } else if (lastFilter === 'EQUIPMENT') {
                dispatcher.trigger('search:filters:render', 'equipment', true, backToPreviousFilters);
              }
            } else if (this.has('filters')) {
              this.get('filters').set({'isResetAllFilters': false}, {'silent': true});
            }

            // Complete rendering only on desktop and tablet or on submit
            if (!DEVICE.isMobile || ['page', 'sort', 'order', 'PROMOCODE'].some(key => arrKeys.includes(key)) || submitForm) {
              this.validateModelUpdates(modifiedKey, urlSeo, facetteDiscount);
            } else {
              // HANDLING MOBILE BEHAVIOURS
              // call flexdate
              dispatcher.trigger('search:flexDates:getFlexDates');
              dispatcher.trigger('search:resultList:render');

              if (facetteDiscount) {
                dispatcher.trigger('facette:discounts:render', facetteDiscount);
              }

              this.updateUrl(urlSeo);
            }
          }
        } else {
          // Enregistrement du json dans le modèle
          this.set({'temporaryJSON_results': datas}, {'silent': true});

          // If temporary model modification, only updating main form
          dispatcher.trigger('searchView:render', modifiedKey, datas.results.filter, true);
        }

        // --- enable submit button for day visitor
        if ($('.js-dayVisitor').length) {
          dispatcher.trigger('search:dayVisitorSuccess', datas);
        }
      }

      // Reset submit value
      this.get('mainSearch').set({'submitForm': false}, {'silent': true});

      // Handling loader for specific filters
      if (['ACTIVITIES', 'HOUSINGCATEGORY', 'HOUSINGSPEC', 'NUMBEROFBEDROOMS', 'EQUIPMENT'].includes(lastFilter)) {
        loader.remove('.js-searchFilters-globalContainer');
      }
    };

    // Reset du cache des filtres
    dispatcher.trigger('search:filters:clearCache');
    // Disable form submit before ajax call
    dispatcher.trigger('searchView:disallowFormAction');

    this.getJsonDatas({
      url: SEARCH_SCRIPTS.URL_API_SEARCH,
      successCallback: globalSearchUpdate_successCallback,
      abortable: true,
      origin: 'globalSearchUpdate',
      isTemp: isTemporaryModel
    });

    if (this.hasResultsList && !isTemporaryModel) {
      this.triggerSearchRequestEvent(1);
    }
  },

  /**
   * @param {boolean} is_user_search
   */
  triggerSearchRequestEvent(is_user_search) {
    /** Fonction déclenchant l'event de tracking "search_request".
     * Cet event, sauf changement est censé se déclencher au chargement d'une page liste de résultats ou via la soumission d'une recherche via Ajax.
     *
     * is_user_search est censé être à 1 uniquement si l'event est déclenché suite à une requête search de type "ajax" ou lors du chargement d'une
     * page si et seulement si le paramètre d'url "user_search" est présent.
     *
     * L'équipe WebA se servira de cette info pour différencier les requêtes de recherche effectuées directement suite à une action de
     * l'utilisateur.
     * */

    const searchModel = this.get('mainSearch');
    const searchModelResume = searchModel.getResume();
    const filtersResume = this.get('filters').getResume();
    const searchFilters = [];
    let destinations = {
      domain_names: [],
      domain_codes: [],
      country_names: [],
      country_codes: []
    };
    if (SEARCH_SCRIPTS.PRODUCT_CODE.length) {
      destinations.domain_names.push(PRODUCT_SCRIPTS.SITENAME);
      destinations.domain_codes.push(PRODUCT_SCRIPTS.PRODUCT_CODE);
      destinations.country_names.push(PRODUCT_SCRIPTS.COUNTRY);
      destinations.country_codes.push(PRODUCT_SCRIPTS.COUNTRY_CODE);
    } else if (!$.isEmptyObject(searchModelResume.parks)) {
      $.each(searchModelResume.parks, park_code => {
        const $checkBoxes = park_code.indexOf('l1') !== -1 ? $('.js-country_' + park_code.split('_')[1] + ' .js-countryCheckbox > input[type="checkbox"]:checked') : $('.js-countryCheckbox > input[type="checkbox"][value="' + park_code + '"]:checked');
        if ($checkBoxes.length) {
          $.each($checkBoxes, (i, checkBox) => {
            const $checkBox = $(checkBox);
            const $countryCheckbox = $checkBox.closest('ul').find('input[type="checkbox"][id^="optionList_country_"]');
            destinations.domain_names.push($checkBox.data('label'));
            destinations.domain_codes.push($checkBox.attr('value').split('_')[1].toUpperCase());
            destinations.country_names.push($countryCheckbox.siblings('label').text().trim());
            destinations.country_codes.push($countryCheckbox.attr('value').split('_')[1].toUpperCase());
          });
        }
      });
      destinations.domain_names = _.uniq(destinations.domain_names);
      destinations.domain_codes = _.uniq(destinations.domain_codes);
      destinations.country_names = _.uniq(destinations.country_names);
      destinations.country_codes = _.uniq(destinations.country_codes);
    }

    if (Object.prototype.hasOwnProperty.call(filtersResume, 'ACTIVITIES') && filtersResume.ACTIVITIES.length) {
      searchFilters.push({
        filterCategory: 'Search',
        filterType: 'Activites',
        filterValues: filtersResume.ACTIVITIES
      });
    }

    if (SEARCH_SCRIPTS.IS_FACETTE_BUDGET_SELECTED && Object.prototype.hasOwnProperty.call(filtersResume, 'PRICE') && filtersResume.PRICE.length) {
      searchFilters.push({
        filterCategory: 'Search',
        filterType: 'Budget',
        filterValues: filtersResume.PRICE
      });
    }

    if (Object.prototype.hasOwnProperty.call(filtersResume, 'CLASSIFICATIONCOMFORT') && filtersResume.CLASSIFICATIONCOMFORT.length) {
      searchFilters.push({
        filterCategory: 'Search',
        filterType: 'Classement du parc',
        filterValues: filtersResume.CLASSIFICATIONCOMFORT
      });
    }

    if (Object.prototype.hasOwnProperty.call(filtersResume, 'HOUSINGCATEGORY') && filtersResume.HOUSINGCATEGORY.length) {
      searchFilters.push({
        filterCategory: 'Search',
        filterType: 'Hebergements',
        filterValues: filtersResume.HOUSINGCATEGORY
      });
    }

    if (Object.prototype.hasOwnProperty.call(filtersResume, 'HOUSINGSPEC') && filtersResume.HOUSINGSPEC.length) {
      searchFilters.push({
        filterCategory: 'Search',
        filterType: 'Hebergements Spécificités',
        filterValues: filtersResume.HOUSINGSPEC
      });
    }

    if (Object.prototype.hasOwnProperty.call(filtersResume, 'NUMBEROFBEDROOMS') && filtersResume.NUMBEROFBEDROOMS.length) {
      searchFilters.push({
        filterCategory: 'Search',
        filterType: 'Nombre de chambre',
        filterValues: filtersResume.NUMBEROFBEDROOMS
      });
    }

    if (Object.prototype.hasOwnProperty.call(filtersResume, 'EQUIPMENT') && filtersResume.EQUIPMENT.length) {
      searchFilters.push({
        filterCategory: 'Search',
        filterType: 'Equipement',
        filterValues: filtersResume.EQUIPMENT
      });
    }

    const searchNames = {
      search: 'Main search',
      country: 'CO',
      destination: 'DE',
      region: 'GE',
      singleclick: 'SCK',
      guide: 'Guide Me',
      product: 'Product Accommodations'
    };

    const searchRequestDatas = {
      event: 'search_request',
      is_user_search: is_user_search,
      search_country_label: destinations.country_names,
      search_country_code: destinations.country_codes,
      search_park_code: destinations.domain_codes,
      search_park_label: destinations.domain_names,
      list_type: 'Accommodations',
      list_sort: searchModel.get('sort') === 'distance' ? 'Distance' : (searchModel.get('sort') === 'Price' ? (searchModel.get('order') === 'desc' ? 'Prix décroissant' : 'Prix croissant') : 'Popularité'),
      search_filters: searchFilters,
      search_engine_type: SEARCH_SCRIPTS.CONTROLLER === 'guide' ? 'inspirationnal' : 'faceted',
      search_number_person_1: searchModelResume.multiparticipants[0].seniors + searchModelResume.multiparticipants[0].adults + searchModelResume.multiparticipants[0].ages.length,
      search_adult_number_1: searchModelResume.multiparticipants[0].adults,
      search_children_age_1: JSON.stringify(searchModelResume.multiparticipants[0].ages),
      search_children_number_1: searchModelResume.multiparticipants[0].ages.length,
      search_pet_number_1: searchModelResume.multiparticipants[0].pets,
      search_senior_number_1: searchModelResume.multiparticipants[0].seniors,
      search_number_person_2: searchModelResume.multiparticipants[1].seniors + searchModelResume.multiparticipants[1].adults + searchModelResume.multiparticipants[1].ages.length,
      search_adult_number_2: searchModelResume.multiparticipants[1].adults,
      search_children_age_2: JSON.stringify(searchModelResume.multiparticipants[1].ages),
      search_children_number_2: searchModelResume.multiparticipants[1].ages.length,
      search_pet_number_2: searchModelResume.multiparticipants[1].pets,
      search_senior_number_2: searchModelResume.multiparticipants[1].seniors,
      search_adult_number: searchModelResume.multiparticipants[0].adults + searchModelResume.multiparticipants[1].adults,
      search_senior_number: searchModelResume.multiparticipants[0].seniors + searchModelResume.multiparticipants[1].seniors,
      search_children_number: searchModelResume.multiparticipants[0].ages.length + searchModelResume.multiparticipants[1].ages.length,
      search_children_age: JSON.stringify(searchModelResume.multiparticipants[0].ages) + JSON.stringify(searchModelResume.multiparticipants[1].ages),
      search_number_person: searchModelResume.multiparticipants[0].seniors + searchModelResume.multiparticipants[0].adults + searchModelResume.multiparticipants[0].ages.length + searchModelResume.multiparticipants[1].seniors + searchModelResume.multiparticipants[1].adults + searchModelResume.multiparticipants[1].ages.length,
      search_pet_number: searchModelResume.multiparticipants[0].pets + searchModelResume.multiparticipants[1].pets,
      multicottage: searchModelResume.accommodationNb === 1 ? 'no' : 'yes',
      search_name: searchNames[GLOBAL_SCRIPTS.CONTROLLER]
    };

    if (searchModelResume.arrivalDate !== null && searchModelResume.arrivalDate.length) {
      searchRequestDatas.search_start_date = searchModelResume.arrivalDate;
      searchRequestDatas.search_lead_time = genericDate.diff(new Date(), new Date(searchModelResume.arrivalDate));
      searchRequestDatas.search_start_day_of_week = new Date(searchModelResume.arrivalDate).toLocaleDateString(undefined, {weekday: 'long'}).replace(/\./gi, '');

      if (searchModelResume.departureDate !== null && searchModelResume.departureDate.length) {
        searchRequestDatas.search_end_date = searchModelResume.departureDate;
        searchRequestDatas.search_length_of_stay = genericDate.diff(new Date(searchModelResume.arrivalDate), new Date(searchModelResume.departureDate));
      }
    }

    Tracking.dataLayerPush(searchRequestDatas);
  },

  /**
   * Update process after model modification
   * @param {string} modifiedModelKey - Clé correspondant au champ modifié en dernier
   * @param {string} urlSeo
   * @param {(boolean|Object)} facetteDiscount
   */
  validateModelUpdates(modifiedModelKey, urlSeo, facetteDiscount = false) {
    // mise à jour des filtres et du moteur principal
    dispatcher.trigger('searchView:render', modifiedModelKey);

    // mise à jour de la liste de résultat
    if (this.hasResultsList) {
      const paginate = this.get('hasPagination') && this.get('page') > 1 && modifiedModelKey === 'page';
      dispatcher.trigger('search:resultList:render', paginate);

      // call flexdate
      dispatcher.trigger('search:flexDates:getFlexDates');
    }

    this.updateUrl(urlSeo);

    if (facetteDiscount) {
      dispatcher.trigger('facette:discounts:render', facetteDiscount);
    }

    // if validateModelUpdates is triggered by validation button on mobile
    if (DEVICE.isMobile) {
      // closing filters
      dispatcher.trigger('search:filters:close');
    }
  },

  /**
   * Update url and submit target
   * @param {string} urlSeo
   */
  updateUrl(urlSeo) {
    if (typeof urlSeo !== 'undefined' && urlSeo !== '' && !this.firstLoad) {
      const urlParamsHistory = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + urlSeo;
      window.history.pushState({
        path: urlParamsHistory
      }, '', urlParamsHistory);
    } else {
      this.firstLoad = false;
    }
  },

  /**
   * Getting all search parameters memorized in model
   * @param {boolean} isTemp
   */
  getSearchParams(isTemp = true) {
    const modelToUse = isTemp ? this.get('temporarySearch') : this.get('mainSearch');
    const contextParameters = this.contextParameters;
    const mainDatas = modelToUse.getResume();
    const filtersData = this.has('filters') ? this.get('filters').getFiltersValues() : {};
    const searchData = $.extend({}, contextParameters, filtersData);

    let ajaxParams = searchData;
    let arrivalDate = false;
    let departureDate = false;

    // Suppression de la liste des résultats du retour, si on n'a pas de liste de résultats
    if (!this.hasResultsList) {
      ajaxParams.results = 0;
    }

    // Initialisation des variables facettes et options
    ajaxParams.facet = ajaxParams.facet || {};
    ajaxParams.option = ajaxParams.option || {};

    // Ajout des paramètres de tri
    ajaxParams.page = this.get('page');
    ajaxParams.nb = this.get('hasPagination') ? 10 : 30; // règle: 10 par page quand pagination, sinon la totalité => on choisit 30 arbitrairement car on a moins de 30 domaines (elastic a besoin d'une limite)
    ajaxParams.sort = this.get('sort');

    // Ajout de paramètres statiques
    ajaxParams.option.formats_results = $('#js-resultList').hasClass('domainAccommodations-resultList') ? '566x250,500x375,362x160' : '640x480,566x250,500x375,400x400,362x160,330x248';
    ajaxParams.option.formats_filters = '566x250,362x160,230x173';

    if (typeof mainDatas.dayType !== 'undefined' && mainDatas.dayType !== '') {
      ajaxParams.dayType = mainDatas.dayType;// stay type for day guest (day or halfday)
    }

    // Règle: on n'affiche les hébergements indisponibles que dans la page product housings
    // (ou dans la liste des hébergements d'un cartouche domaine, mais c'est géré dans la fonction displayHousings)
    if (searchData._controller === 'product') {
      ajaxParams.facet.DISPO = -1;
    }

    // Handling lat & long for distance in results
    const cookieUserLocation = cookieManagement.getCookie('userLocation');
    if (cookieUserLocation !== null) {
      const oUserLocation = JSON.parse(cookieUserLocation);
      ajaxParams.user_geo_lat = oUserLocation.lat;
      ajaxParams.user_geo_lon = oUserLocation.long;
    }

    if (mainDatas.lat !== null && mainDatas.long !== null) {
      ajaxParams.user_geo_lat = mainDatas.lat;
      ajaxParams.user_geo_lon = mainDatas.long;
    }

    if (this.get('order') !== '') {
      ajaxParams.asc = this.get('order');
    } else if (SEARCH_SCRIPTS.ORDER_BY !== '') {
      ajaxParams.asc = SEARCH_SCRIPTS.ORDER_BY;
    }

    ajaxParams.accreditation = GLOBAL_SCRIPTS.ACCREDITATION;
    ajaxParams.accreditationGroup = GLOBAL_SCRIPTS.ACCREDITATION_GROUP;
    ajaxParams.cacheuser = GLOBAL_SCRIPTS.CACHE_USER;

    // Ajout dans les paramètres des données du formulaire principal
    if (mainDatas.arrivalDate) {
      arrivalDate = mainDatas.arrivalDate;
      ajaxParams.facet.DATE = mainDatas.arrivalDate;
    } else if (sessionStorage.getItem('basketDatas') !== null) {
      arrivalDate = JSON.parse(sessionStorage.getItem('basketDatas')).dateStart;
      ajaxParams.facet.DATE = JSON.parse(sessionStorage.getItem('basketDatas')).dateStart;
    }

    if (mainDatas.departureDate && mainDatas.departureDate !== '') {
      departureDate = mainDatas.departureDate;
      ajaxParams.facet.DATEEND = mainDatas.departureDate;
    } else if (sessionStorage.getItem('basketDatas') !== null) {
      departureDate = JSON.parse(sessionStorage.getItem('basketDatas')).dateEnd;
      ajaxParams.facet.DATEEND = JSON.parse(sessionStorage.getItem('basketDatas')).dateEnd;
    }

    if (mainDatas.duration) {
      if (mainDatas.duration === 'weekend') {
        ajaxParams.facet.DAYOFWEEKCP = 4;
        ajaxParams.facet.DURATIONCP = [2];
      } else if (mainDatas.duration < 10) {
        ajaxParams.facet.DURATIONCP = [mainDatas.duration];
      } else {
        ajaxParams.facet.DURATIONCP = [10, 11, 12, 13, 14];
      }
    } else {
      if (SEARCH_SCRIPTS.DURATION_DEFAULT && JSON.parse(SEARCH_SCRIPTS.DURATION_DEFAULT).length) {
        // Règle: si la facette duration a des valeurs par défaut de paramétrées (sck),
        // on ne les envoie que si aucune valeur n'est choisie par l'utilisateur
        ajaxParams.facet.DURATIONCP = JSON.parse(SEARCH_SCRIPTS.DURATION_DEFAULT);
      }
    }

    /**
     * SCK && DATE RANGE RELATED RULES
     * s'il y a un 'date-range' et que :
     * - l'utilisateur n'a pas renseigné de date
     *    ⇒ on doit transmettre le dateuser=0 à chaque appel + les bornes du 'date-range', pour que ces dernières soient utilisées côté serveur
     * - l'utilisateur supprime des dates après en avoir renseigné,
     *    ⇒ il faut passer l'init=1, pour qu'on sache du côté serveur qu'il faut réutiliser les bornes du 'date-range'
     */
    ajaxParams.dateuser = arrivalDate || departureDate ? 1 : 0;

    /*** HANDLING FORCED DATERANGE IN THE URL (example : daterange=20190610-20190617) ***/
    if (typeof isForcedRange !== 'undefined' && isForcedRange) {
      if (arrivalDate && mainDatas.arrivalDate !== defaultDateStart && (departureDate || (departureDate && mainDatas.departureDate !== defaultDateEnd))) {
        ajaxParams.dateuser = 1;
      } else {
        ajaxParams.dateuser = 0;
      }
    }

    if (typeof isDateRange !== 'undefined' && isDateRange && searchData._controller === 'singleclick') {
      ajaxParams.option.date_range = 1;
    }

    if (mainDatas.isFlexPeriod || mainDatas.duration) {
      ajaxParams.option.date_range = 1;
      ajaxParams.option.flexholiday = 1;
      ajaxParams.dateuser = 0;
    }

    /**
     * PREVENT THE USE OF DATES IN THE ERESA RETURN,
     * IF USER DOESN'T FILL UP DATES (because link to eresa will use default dates in this case)
     */
    if (!arrivalDate) {
      ajaxParams.option.defaultDate = 1;
    }

    if (searchData._controller === 'singleclick' && ajaxParams.dateuser === 0 && typeof ajaxParams.facet.DATE === 'undefined' && typeof ajaxParams.facet.DATEEND === 'undefined') {
      if (typeof isForcedRange !== 'undefined' && isForcedRange && (dateRangeStart !== '' || dateRangeEnd !== '')) {
        ajaxParams.facet.DATE = dateRangeStart;
        ajaxParams.facet.DATEEND = dateRangeEnd;
      } else {
        ajaxParams.init = 1;
      }
    }

    const parks = mainDatas.parks;
    if (!$.isEmptyObject(parks)) {
      ajaxParams.facet.COUNTRYSITE = [];
      ajaxParams.country_site_referer = [];

      for (const park in parks) {
        ajaxParams.facet.COUNTRYSITE.push(park);
        ajaxParams.country_site_referer.push(park);
      }

    } else if (mainDatas.hasDefaultSite) {
      ajaxParams.facet.COUNTRYSITE = [];
    }

    if (SEARCH_SCRIPTS.PRODUCT_CODE !== '') {
      ajaxParams.facet.COUNTRYSITE = [];
      ajaxParams.facet.COUNTRYSITE.push('l2_' + SEARCH_SCRIPTS.PRODUCT_CODE);
    } else if (sessionStorage.getItem('basketDatas') !== null) {
      ajaxParams.facet.COUNTRYSITE = [];
      ajaxParams.facet.COUNTRYSITE.push(JSON.parse(sessionStorage.getItem('basketDatas')).domaincode);
    }

    if (SEARCH_SCRIPTS.DISPLAY_PRICE !== '') {
      ajaxParams.displayPrice = SEARCH_SCRIPTS.DISPLAY_PRICE;
    }


    ajaxParams.facet.MULTIPARTICIPANTS = ajaxParams.facet.MULTIPARTICIPANTS || [{}, {}];
    ajaxParams.facet.MULTIPARTICIPANTS[0].adult = isNaN(mainDatas.multiparticipants[0].adults) ? 2 : mainDatas.multiparticipants[0].adults;

    if (SEARCH_SCRIPTS.IS_DAY_VISITOR) {
      ajaxParams.facet.MULTIPARTICIPANTS[0].child = isNaN(mainDatas.multiparticipants[0].children) ? 0 : mainDatas.multiparticipants[0].children;
      ajaxParams.facet.MULTIPARTICIPANTS[0].baby = isNaN(mainDatas.multiparticipants[0].babies) ? 0 : mainDatas.multiparticipants[0].babies;
    } else {
      ajaxParams.facet.MULTIPARTICIPANTS[0].senior = isNaN(mainDatas.multiparticipants[0].seniors) ? 0 : mainDatas.multiparticipants[0].seniors;
      ajaxParams.facet.MULTIPARTICIPANTS[0].pet = isNaN(mainDatas.multiparticipants[0].pets) ? 0 : mainDatas.multiparticipants[0].pets;
    }

    if (mainDatas.multiparticipants[0].ages.length) {
      ajaxParams.facet.MULTIPARTICIPANTS[0].ages = mainDatas.multiparticipants[0].ages;
    }

    if (mainDatas.accommodationNb === 2) {
      ajaxParams.option.multicottage = {
        nb: mainDatas.accommodationNb
      };
      ajaxParams.facet.MULTIPARTICIPANTS[1].adult = isNaN(mainDatas.multiparticipants[1].adults) ? 0 : mainDatas.multiparticipants[1].adults;
      ajaxParams.facet.MULTIPARTICIPANTS[1].senior = isNaN(mainDatas.multiparticipants[1].seniors) ? 0 : mainDatas.multiparticipants[1].seniors;
      ajaxParams.facet.MULTIPARTICIPANTS[1].pet = isNaN(mainDatas.multiparticipants[1].pets) ? null : mainDatas.multiparticipants[1].pets;

      if (mainDatas.multiparticipants[1].ages.length) {
        ajaxParams.facet.MULTIPARTICIPANTS[1].ages = mainDatas.multiparticipants[1].ages;
      }

      ajaxParams.option.multicottage.nb = mainDatas.accommodationNb;
      ajaxParams.option.multicottage.selected = {};
      ajaxParams.option.multicottage.actionCode = {};

      if (sessionStorage.getItem('basketDatas') !== null) {
        const basketDatas = JSON.parse(sessionStorage.getItem('basketDatas'));

        let countCottagesFilled = 0;

        $.each(basketDatas.cottagesSelected, (index, cottage) => {
          if (cottage.isFilled) {
            countCottagesFilled++;
            ajaxParams.option.multicottage.selected[index] = cottage.housingCode;
            ajaxParams.option.multicottage.actionCode[index] = cottage.actionCode;
          }
        });

        ajaxParams.option.multicottage.list = countCottagesFilled > 0 && basketDatas.cottagesSelected[1] !== undefined && basketDatas.cottagesSelected[1].isFilled ? 0 : 1;
      }
    }

    // Referer pour la resa dans le cas des cartouches housing
    let referer = window.location.protocol + '//' + window.location.host + window.location.pathname;
    ajaxParams.referer = encodeURIComponent(referer);

    // Handling portalcode
    if (SEARCH_SCRIPTS.PORTAL_CODE !== '') {
      ajaxParams.facet.PROMOCODE = ajaxParams.facet.PROMOCODE || {};
      ajaxParams.facet.PROMOCODE.portalCode = SEARCH_SCRIPTS.PORTAL_CODE;
    }

    // Handling parks biasing search
    if (SEARCH_SCRIPTS.COLLECTION !== GLOBAL_SCRIPTS.UNIVERS.toUpperCase() + '_GEO' && (ajaxParams.sort === 'popularity' || ajaxParams.sort === 'popularity_housing')) {
      ajaxParams.option.biasingParams = cookieManagement.getCookie('biasingSearchParams') !== null ? cookieManagement.getCookie('biasingSearchParams') : {};
    }

    ajaxParams.option.seasonCycle = getSeason(ajaxParams.facet.DATE !== '' ? ajaxParams.facet.DATE : new Date().toISOString().split('T')[0]);

    // Affectation du résultat dans le cache du modèle, pour en disposer après un trigger
    if (isTemp) {
      this.set({'ajaxParametersTempCache': ajaxParams}, {'silent': true});
    } else {
      this.set({'ajaxParametersCache': ajaxParams}, {'silent': true});
    }

    // Update model for popin cottage detail or Flexdate
    const $flexDates = $('#js-flexDates');

    if ($('body').hasClass('popinCottage') || ($flexDates.length && $flexDates.hasClass('loading'))) {
      ajaxParams.facet.DATE = $('.js-search-arrivalInput').val();
      ajaxParams.facet.DATEEND = $('.js-search-departureInput').val();
      this.get('temporarySearch').set({
        'arrivalDate': ajaxParams.facet.DATE,
        'departureDate': ajaxParams.facet.DATEEND
      });
      this.get('mainSearch').set({
        'arrivalDate': ajaxParams.facet.DATE,
        'departureDate': ajaxParams.facet.DATEEND
      });
    }
  },

  /**
   * Getting json by ajax or memorized version
   * @param {Object} ajaxDatas
   * @param {boolean} ajaxDatas.abortable
   * @param {Object} ajaxDatas.ajaxParams
   * @param {Object} ajaxDatas.dayVisitorError
   * @param {boolean} ajaxDatas.isTemp
   * @param {string} ajaxDatas.origin
   * @param {Function} ajaxDatas.successCallback
   * @param {string} ajaxDatas.url
   */
  getJsonDatas(ajaxDatas) {
    // Récupération des données ajax des filtres
    dispatcher.trigger('searchModel:updateSearchParams', ajaxDatas.isTemp);

    const $dayVisitor = $('.js-dayVisitor');
    let ajaxParams = ajaxDatas.isTemp ? this.get('ajaxParametersTempCache') : this.get('ajaxParametersCache');
    ajaxParams._controller = SEARCH_SCRIPTS.CONTROLLER;

    if ($dayVisitor.length) {
      const dayVisitorAdults = typeof ajaxParams.facet.MULTIPARTICIPANTS[0].adult !== 'undefined' ? ajaxParams.facet.MULTIPARTICIPANTS[0].adult : 0;
      const dayVisitorChildren = typeof ajaxParams.facet.MULTIPARTICIPANTS[0].child !== 'undefined' ? ajaxParams.facet.MULTIPARTICIPANTS[0].child : 0;
      const dayVisitorBabies = typeof ajaxParams.facet.MULTIPARTICIPANTS[0].baby !== 'undefined' ? ajaxParams.facet.MULTIPARTICIPANTS[0].baby : 0;
      const dayVisitorDate = typeof ajaxParams.facet.DATE !== 'undefined' ? ajaxParams.facet.DATE : 0;
      const dayVisitorDaytype = typeof ajaxParams.dayType !== 'undefined' ? ajaxParams.dayType : 0;

      ajaxDatas.successCallback = 'search:dayvisitor:success';

      const paramsObj = {
        market: GLOBAL_SCRIPTS.MARKET_CODE,
        date: dayVisitorDate,
        adults: dayVisitorAdults,
        children: dayVisitorChildren,
        babies: dayVisitorBabies,
        dtype: dayVisitorDaytype
      };
      const searchParams = new URLSearchParams(paramsObj);

      ajaxDatas.url = `/bypass/json/dayguest?${searchParams.toString()}`;
    }

    // Requète ajax pour récupérer le JSON des filtres
    const ajaxData = {
      ajaxUrl: ajaxDatas.url,
      ajaxParams: ajaxParams,
      successCallback: ajaxDatas.successCallback,
      errorCallback: typeof ajaxDatas.dayVisitorError !== 'undefined' ? ajaxDatas.dayVisitorError : {},
      abortable: typeof ajaxDatas.abortable !== 'undefined' ? ajaxDatas.abortable : false,
      origin: typeof ajaxDatas.origin !== 'undefined' ? ajaxDatas.origin : '',
      dataType: 'json',
      type: 'GET'
    };

    if ($dayVisitor.length) {
      delete ajaxData.ajaxParams;
    }

    genericAjaxCall(ajaxData);
  }
});

/**
 * Model du moteur principal park/dates/participants
 */
const MainEngineModel = Backbone.Model.extend({
  defaults: {
    parks: {},
    parksDisabled: {},
    parksFieldLabel: false,
    hasDefaultSite: false,
    arrivalDate: null,
    departureDate: null,
    duration: null,
    dayType: 'day', // for day visitor differenciation
    capacity: '2_99',
    nights: 0,
    submitForm: false,
    accommodationNb: 1,
    isTemp: false,
    multiparticipants: [{
      adults: 2,
      seniors: 0,
      children: 0,
      babies: 0,
      pets: 0,
      ages: []
    }, {
      adults: 0,
      seniors: 0,
      children: 0,
      babies: 0,
      pets: 0,
      ages: []
    }],
    cottageSelected: sessionStorage.getItem('basketDatas') !== null && JSON.parse(sessionStorage.getItem('basketDatas')).cottagesSelected.length > 0 ? JSON.parse(sessionStorage.getItem('basketDatas')).cottagesSelected[0].housingCode : '',
    totalParticipants: 2, // nombre de participants affichés (adultes + seniors + enfants + bébés)
    participantsRules: {
      adults: {
        default: 2,
        max: 18,
        min: typeof isFacetteMultiParticipants !== 'undefined' ? 0 : 1
      },
      seniors: {
        default: 0,
        max: 18,
        min: 0
      },
      children: {
        default: 0,
        max: 12,
        min: 0
      },
      babies: {
        default: 0,
        max: 12
      },
      pets: {
        default: 0,
        max: 2
      },
      maxParticipants: 18, // maximum de participants affichable (adultes + bébés), => différent de la capacité maximum
      ages: {
        default: []
      }
    }
  },

  /**
   * Init Main Engine Model
   * @param {boolean} init
   */
  initialize(init = true) {
    if (init) {
      // Si cookie storedSearchParams, on récupère les valeurs de ce cookie
      // Si pas de cookie, 2 cas, si il y a des paramètres dans l'url, on applique ces paramètres soit on applique les valeurs par défaut
      const storedSearchParams = JSON.parse(cookieManagement.getCookie('storedSearchParams')) || {};
      const hasStoredSearchParams = !!(Object.keys(storedSearchParams).length);
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      // Instanciation des valeurs
      let arrivalDate = GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' ? '' : SEARCH_SCRIPTS.DATE_SELECTED;
      let departureDate = GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' ? '' : SEARCH_SCRIPTS.DATE_END_SELECTED;
      let nights = '';
      let nbAdults = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].ADULTS_SELECTED;
      let nbSeniors = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].SENIORS_SELECTED;
      let nbChildren = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].AGES_SELECTED.length;
      let nbPets = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].PETS_SELECTED;
      let nbAdults2 = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].ADULTS_SELECTED;
      let nbSeniors2 = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].SENIORS_SELECTED;
      let nbChildren2 = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].AGES_SELECTED.length;
      let nbPets2 = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].PETS_SELECTED;
      let participantsModified = false;
      let nbCottage = SEARCH_SCRIPTS.TOTALCOTTAGE;
      let ages = SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].AGES_SELECTED;
      let ages2 = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].AGES_SELECTED;
      let duration = null;
      let isFlexPeriod = false;
      let flexZone = '';
      let params = {};

      if (SEARCH_SCRIPTS.IS_FACET_PARTICIPANTS || SEARCH_SCRIPTS.IS_DAY_VISITOR) {
        params.multiparticipants = [];

        // check if dates are alreday passed
        const today = new Date(new Date().setHours(0, 0, 0, 0));
        const cookieDate = Object.keys(storedSearchParams).length && typeof storedSearchParams.date !== 'undefined' ? new Date(storedSearchParams.date[0].value) : false;
        const cookieDateEnd = Object.keys(storedSearchParams).length && typeof storedSearchParams.dateend !== 'undefined' ? new Date(storedSearchParams.dateend[0].value) : false;

        if ((cookieDate && cookieDate < today) || (cookieDateEnd && cookieDateEnd < today)) {
          delete storedSearchParams.date;
          delete storedSearchParams.dateend;
          cookieManagement.createCookie('storedSearchParams', JSON.stringify(storedSearchParams), 365);
        }

        if (((hasStoredSearchParams && GLOBAL_SCRIPTS.CONTROLLER !== 'singleclick') || queryString.indexOf('fromresa') !== -1) && !$('.js-esiNoPrice').length) {
          arrivalDate = !!storedSearchParams.date ? storedSearchParams.date[0].value : null;
          departureDate = !!storedSearchParams.dateend ? storedSearchParams.dateend[0].value : null;

          let parks = {};
          if (Object.keys(storedSearchParams).length && typeof storedSearchParams.countrysite !== 'undefined') {
            $.each(storedSearchParams.countrysite, (_index, countrysite) => {
              const key = countrysite.key;
              parks[key] = true;
            });

            params.parks = parks;
          }

          const hasStoredMultiparticipants = Object.keys(storedSearchParams).length && typeof storedSearchParams.multiparticipants !== 'undefined';
          const hasStoredMultiparticipants1 = hasStoredMultiparticipants && Object.keys(storedSearchParams.multiparticipants).length;
          const storedMultiparticipants = hasStoredMultiparticipants1 ? storedSearchParams.multiparticipants[0] : {};
          const hasStoredMultiparticipants2 = hasStoredMultiparticipants && Object.keys(storedSearchParams.multiparticipants).length > 1;
          const storedMultiparticipants2 = hasStoredMultiparticipants2 ? storedSearchParams.multiparticipants[1] : {};
          const hasStoredChildren = Object.keys(storedMultiparticipants).length && storedMultiparticipants.ages.length;
          const hasStoredChildren2 = Object.keys(storedMultiparticipants2).length && storedMultiparticipants2.ages.length;

          let storeAges = [],
            storeAges2 = [];
          if (hasStoredChildren) {
            $.each(storedMultiparticipants.ages, (_index, age) => {
              storeAges.push(parseInt(typeof age.value !== 'undefined' ? age.value : age));
            });
          }
          ages = storeAges;

          if (hasStoredChildren2) {
            $.each(storedMultiparticipants2.ages, (_index, age) => {
              storeAges2.push(parseInt(typeof age.value !== 'undefined' ? age.value : age));
            });
          }
          ages2 = storeAges2;

          if (Object.keys(storedMultiparticipants).length) {
            nbAdults = parseInt(storedMultiparticipants.adult.value);
            nbSeniors = parseInt(storedMultiparticipants.senior.value);
            nbChildren = storeAges.length;
            nbPets = parseInt(storedMultiparticipants.pet.value);
          }
          nbAdults2 = Object.keys(storedMultiparticipants2).length ? parseInt(storedMultiparticipants2.adult.value) : 0;
          nbSeniors2 = Object.keys(storedMultiparticipants2).length ? parseInt(storedMultiparticipants2.senior.value) : 0;
          nbChildren2 = Object.keys(storedMultiparticipants2).length ? storeAges2.length : 0;
          nbPets2 = Object.keys(storedMultiparticipants2).length ? parseInt(storedMultiparticipants2.pet.value) : 0;
          nbCottage = Object.keys(storedMultiparticipants2).length ? 2 : 1;
          isFlexPeriod = hasStoredSearchParams && typeof storedSearchParams.isFlexPeriod !== 'undefined' ? storedSearchParams.isFlexPeriod : false;
          flexZone = hasStoredSearchParams && typeof storedSearchParams.flexZone !== 'undefined' ? storedSearchParams.flexZone : '';
          duration = hasStoredSearchParams && typeof storedSearchParams.duration !== 'undefined' ? storedSearchParams.duration[0].value : null;
        } else if (urlParams.size > 0) {
          arrivalDate = queryString.indexOf('facet[DATE]') !== -1 && new Date(urlParams.get('facet[DATE]')) >= today ? urlParams.get('facet[DATE]') : null;
          departureDate = queryString.indexOf('facet[DATEEND]') !== -1 && new Date(urlParams.get('facet[DATEEND]')) >= today ? urlParams.get('facet[DATEEND]') : null;
          const dateCorrect = !!arrivalDate && !!departureDate && new Date(urlParams.get('facet[DATEEND]')) - new Date(urlParams.get('facet[DATE]')) > 0;
          nights = dateCorrect ? genericDate.diff(new Date(arrivalDate), new Date(departureDate)) : null;

          let parks = {};
          if (queryString.indexOf('facet[COUNTRYSITE][]') !== -1) {
            $.each(urlParams.getAll('facet[COUNTRYSITE][]'), (_index, park) => {
              parks[park] = true;
            });

            params.parks = parks;
          }

          if (queryString.indexOf('facet[MULTIPARTICIPANTS][0]') !== -1) {
            const hasMulticottage = queryString.indexOf('facet[MULTIPARTICIPANTS][1]') !== -1;

            let paramsAges = [],
              paramsAges2 = [];
            if (queryString.indexOf('facet[MULTIPARTICIPANTS][0][ages][]') !== -1) {
              $.each(urlParams.getAll('facet[MULTIPARTICIPANTS][0][ages][]'), (_index, age) => {
                paramsAges.push(parseInt(age));
              });
              ages = paramsAges;
            }

            nbAdults = parseInt(urlParams.get('facet[MULTIPARTICIPANTS][0][adult]'));
            nbSeniors = parseInt(urlParams.get('facet[MULTIPARTICIPANTS][0][senior]'));
            nbChildren = paramsAges.length;
            nbPets = parseInt(urlParams.get('facet[MULTIPARTICIPANTS][0][pet]'));

            if (hasMulticottage) {
              if (queryString.indexOf('facet[MULTIPARTICIPANTS][1][ages][]') !== -1) {
                $.each(urlParams.getAll('facet[MULTIPARTICIPANTS][1][ages][]'), (_index, age) => {
                  paramsAges2.push(parseInt(age));
                });

                ages2 = paramsAges2;
              }

              nbAdults2 = parseInt(urlParams.get('facet[MULTIPARTICIPANTS][1][adult]'));
              nbSeniors2 = parseInt(urlParams.get('facet[MULTIPARTICIPANTS][1][senior]'));
              nbChildren2 = paramsAges2.length;
              nbPets2 = parseInt(urlParams.get('facet[MULTIPARTICIPANTS][1][pet]'));
              nbCottage = 2;
            }

            if (queryString.indexOf('option[flexholiday]') !== -1) {
              isFlexPeriod = true;
              if (queryString.indexOf('facet[DURATIONCP][]') !== -1) duration = urlParams.get('facet[DURATIONCP][]');
              if (queryString.indexOf('flexZone') !== -1) flexZone = urlParams.get('flexZone');
            }
          }
        }

        params.multiparticipants.push({
          adults: nbAdults,
          seniors: nbSeniors,
          children: nbChildren,
          ages: ages,
          pets: nbPets
        }, {
          adults: nbAdults2,
          seniors: nbSeniors2,
          children: nbChildren2,
          ages: ages2,
          pets: nbPets2
        });

        params.totalParticipants = nbAdults + nbSeniors + nbChildren + nbAdults2 + nbSeniors2 + nbChildren2;

        participantsModified = nbAdults !== 2 || nbSeniors !== 0 || nbChildren !== 0 || nbPets !== 0
          || nbAdults2 !== 2 || nbSeniors2 !== 0 || nbChildren2 > 0 || nbPets2 !== 0;

        params.accommodationNb = nbCottage;
        params.capacity = 0;

      } else {
        params.capacity = this.get('participantsRules').adults.default;
        params.totalParticipants = params.capacity;
      }

      // Récupération des rules pour le participant, instancié dans le twig de la facette multiparticipants
      if (typeof oParticipantsRules !== 'undefined') {
        this.set({'participantsRules': oParticipantsRules}, {silent: true});
      }

      if (!!arrivalDate && !!departureDate) nights = genericDate.diff(new Date(arrivalDate), new Date(departureDate));

      params.arrivalDate = arrivalDate;
      params.departureDate = departureDate;
      params.nights = nights;
      params.isFlexPeriod = isFlexPeriod;
      params.flexZone = flexZone;
      params.duration = duration;
      params.sort = SEARCH_SCRIPTS.DEFAULT_SORTING;
      params.discounts = typeof defaultDiscountValue !== 'undefined' ? defaultDiscountValue : '';
      this.set(params, {'silent': false});

      // Instanciation du code site pour les pages produits
      if (SEARCH_SCRIPTS.CONTROLLER === 'product' && SEARCH_SCRIPTS.PRODUCT_CODE !== '') {
        const parksValue = {};
        parksValue['l2_' + SEARCH_SCRIPTS.PRODUCT_CODE] = true;
        this.set({'parks': parksValue}, {silent: true});
      }

      // HANDLING POPIN PARTICIPANTS: instanciation de l'information permettant de mémoriser que les participants ont été modifiés (pour popin participants)
      SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED = participantsModified;
      SEARCH_SCRIPTS.DATE_SELECTED = arrivalDate;
      SEARCH_SCRIPTS.DATE_END_SELECTED = departureDate;
      SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].ADULTS_SELECTED = nbAdults;
      SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].SENIORS_SELECTED = nbSeniors;
      SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].AGES_SELECTED = ages;
      SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].PETS_SELECTED = nbPets;
      SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].ADULTS_SELECTED = nbAdults2;
      SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].SENIORS_SELECTED = nbSeniors2;
      SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].AGES_SELECTED = ages2;
      SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].PETS_SELECTED = nbPets2;
      SEARCH_SCRIPTS.TOTALCOTTAGE = nbCottage;
      SEARCH_SCRIPTS.TOTALPARTICIPANTS = params.totalParticipants;
    }

    // Gestion des model watch
    this.stopListening(this, 'change');
    this.listenTo(this, 'change', this.modelWatch, true);
  },

  modelWatch() {
    const arrKeys = Object.keys(this.changedAttributes());
    const arrKeysToWatch = [
      'arrivalDate',
      'departureDate',
      'capacity',
      'parks',
      'multiparticipants',
      'totalParticipants',
      'accommodationNb',
      'duration',
      'submitForm',
      'dayType',
      'is_ESI_init'
    ];
    const isTemporaryModel = this.get('isTemp');

    // Si des valeurs impactantes du modèle changent, on déclenche l'enchainement des réactions
    if (_.indexOf(arrKeys, 'resume') === -1 && _.intersection(arrKeys, arrKeysToWatch).length) {
      dispatcher.trigger('searchModel:globalSearchUpdate', {
        isTemporaryModel: isTemporaryModel,
        arrKeys: arrKeys
      });
    }
  },

  /**
   * Get resume of this model
   * @return {Object}
   */
  getResume() {
    const resume = {
      parks: this.get('parks'),
      parksDisabled: this.get('parksDisabled'),
      cottageSelected: this.get('cottageSelected'),
      arrivalDate: this.get('arrivalDate'),
      departureDate: this.get('departureDate'),
      duration: this.get('duration'),
      capacity: this.get('capacity'),
      multiparticipants: [{
        adults: this.get('multiparticipants')[0].adults,
        seniors: this.get('multiparticipants')[0].seniors,
        ages: this.get('multiparticipants')[0].ages,
        pets: this.get('multiparticipants')[0].pets
      }, {
        adults: this.get('multiparticipants')[1].adults,
        seniors: this.get('multiparticipants')[1].seniors,
        ages: this.get('multiparticipants')[1].ages,
        pets: this.get('multiparticipants')[1].pets
      }],
      accommodationNb: this.get('accommodationNb'),
      nights: this.get('nights'),
      hasDefaultSite: this.get('hasDefaultSite'),
      totalParticipants: this.get('totalParticipants'),
      dayType: this.get('dayType'),
      isFlexPeriod: this.get('isFlexPeriod'),
      flexZone: this.get('flexZone')
    };

    this.set('resume', resume, {'silent': true});

    return resume;
  }
});

export { SearchModel, MainEngineModel };